import React, { Component } from 'react';
import { TableDefault, Breadcrumb } from '../../../../components';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      type: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: '/ProdutoCategoria',
      urlEdit: '/admin/grupo/produtos/editar/',
      urlLoad:  'ProdutoCategoria/GetListagem/',
      manager: null
    };
  }

  componentWillMount() {
    this.managerVisited();
  }

  create = () => {
    const { history, match } = this.props;
    const urlGo =
      match.url === '/admin/categorias/produtos'
        ? '/admin/categoria/produtos/editar'
        : '/admin/grupo/produtos/editar';

    history.push(urlGo);
  };

  managerVisited = () => {
    const { match: propMatch } = this.props;
    
    const urlVisited = propMatch.url;
    const group = urlVisited.match(/grupos/);
    const typeConst =  group ? 1 : 2
    this.setState({
      manager: group ? 'group' : 'category',
      urlEdit: group
        ? '/admin/grupo/produtos/editar/'
        : '/admin/categoria/produtos/editar/',        
        type: typeConst
    });
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      type,
      manager
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title={
            manager === 'group'
              ? 'Grupos (produtos agência)'
              : 'Categorias'
          }
          description={
            manager === 'group'
              ? 'Gerencie grupos de produtos agência.'
              : 'Gerencie categorias de produtos.'
          }
          renderRight={(() => (
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={this.create}
              >
                {manager === 'group' ? 'Criar Grupo' : 'Criar Categoria'}
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper">
          <TableDefault
            search={search}
            type={type}
            order={order}
            orderBy={orderBy}
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            onRef={ref => (this.tableList = ref)}
          />
        </section>
      </div>
    );
  }
}
export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManageGroups/List.js